import apiServices from "../../../services/apiService";
import storageService from "../../../utils/storageService";

const bearer = { "X-Use-Bearer": true };

export const communicationApi = {
  settings: (siteId) =>
    apiServices({ method: "GET", url: `Common/Communication/settings?siteId=${siteId}`, headers: bearer }),
  saveSettings: (data) =>
    apiServices({ method: "PUT", url: "Common/Communication/settings", data, headers: bearer }),
  createConversation: (data) =>
    apiServices({ method: "POST", url: "Common/Communication/conversations", data, headers: bearer }),
  listConversations: (siteId) =>
    apiServices({ method: "POST", url: "Common/Communication/conversations/list", data: { siteId }, headers: bearer }),
  members: (data, action) =>
    apiServices({ method: "POST", url: `Common/Communication/conversations/members?action=${action}`, data, headers: bearer }),
  listMembers: (conversationId) =>
    apiServices({ method: "GET", url: `Common/Communication/conversations/${conversationId}/members`, headers: bearer }),
  listSitePeople: (siteId) => {
    const tenant = String(storageService.getItem("Tenant_Name") || "").toLowerCase();
    const residential = ["cascade", "zentres", "localhost", "127"].includes(tenant);
    const path = residential
      ? `Residential/ResUserDetails/getUserDetails?SiteId=${siteId}&PageNumber=1&PageSize=500`
      : `CommUserDetails/getUserDetails?SiteId=${siteId}&PageNumber=1&PageSize=500`;
    return apiServices({ method: "GET", url: path });
  },
  sendMessage: (data) =>
    apiServices({ method: "POST", url: "Common/Communication/messages", data, headers: bearer }),
  listMessages: (conversationId) =>
    apiServices({ method: "POST", url: "Common/Communication/messages/list", data: { conversationId }, headers: bearer }),
  startCall: (data) =>
    apiServices({ method: "POST", url: "Common/Communication/calls/start", data, headers: bearer }),
  endCall: (data) =>
    apiServices({ method: "POST", url: "Common/Communication/calls/end", data, headers: bearer }),
  logout: (userId) =>
    apiServices({ method: "POST", url: "Auth/logOut", data: { userId }, headers: bearer }),
};
